import { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { TvMinimalPlay } from "lucide-react";
import socket from "services/socket";

export default function HlsLiveView() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isStreaming, setIsStreaming] = useState(false);

  const streamingKey = "test";
  const streamSrc = `http://192.168.100.11:8001/live/${streamingKey}/index.m3u8`;

  const initializeHls = () => {
    if (!videoRef.current) return;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(streamSrc);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.warn("HLS.js error:", data);
        if (data.fatal) {
          setTimeout(() => {
            hls.loadSource(streamSrc);
            hls.attachMedia(videoRef.current!);
          }, 3000);
        }
      });
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      // For Safari or browsers with native HLS support
      videoRef.current.src = streamSrc;
    }
  };

  useEffect(() => {
    socket.on("OnFlipFlopStreamStarted", () => {
      setIsStreaming(true);
      initializeHls();
    });

    socket.on("OnFlipFlopStreamEnded", () => {
      setIsStreaming(false);
      if (videoRef.current) videoRef.current.pause();
    });

    socket.emit("viewerJoin", streamingKey);

    return () => {
      socket.emit("viewerLeave", streamingKey);
      socket.off("OnFlipFlopStreamStarted");
      socket.off("OnFlipFlopStreamEnded");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-black flex items-center justify-center min-h-screen p-4">
      <div className="relative" style={{ width: "640px", height: "360px" }}>
        {!isStreaming && (
          <div className="absolute inset-0 flex flex-col items-center justify-center space-y-3 bg-black z-10">
            <TvMinimalPlay className="text-white w-12 h-12" />
            <p className="text-white text-center text-sm">Connect streaming software to go live</p>
          </div>
        )}

        <video ref={videoRef} className={`${isStreaming ? "block" : "hidden"} w-full h-full rounded bg-black`} controls muted autoPlay />
      </div>
    </div>
  );
}

